import request from "../utils/request";
import da from "element-ui/src/locale/lang/da";


export function saveMail(data) {
  return request({
    url: '/systems/mail',
    method: 'post',
    data: data
  })
}

export function getMailInfo() {
  return request({
    url: '/systems/mail',
    method: 'get'
  })
}

export function saveSocial(data) {
  return request({
    url: '/systems/social',
    method: 'post',
    data: data
  })
}

export function getSocialInfo() {
  return request({
    url: '/systems/social',
    method: 'get'
  })
}

export function savePortal(data) {
  return request({
    url: '/systems/portal',
    method: 'post',
    data: data
  })
}

export function getPortalInfo() {
  return request({
    url: '/systems/portal',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/system.js